var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeIconBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66406C5.40484 1.66406 1.6665 5.4024 1.6665 9.9974C1.6665 14.5924 5.40484 18.3307 9.99984 18.3307C14.5948 18.3307 18.3332 14.5924 18.3332 9.9974C18.3332 5.4024 14.5948 1.66406 9.99984 1.66406ZM12.744 13.9199L9.1665 10.3424V4.9974H10.8332V9.6524L13.9223 12.7416L12.744 13.9199Z",
    fill: "#5DB6CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIconBold);
export default __webpack_public_path__ + "static/media/timeIconBold.6cf9f898174359e96fee979704548ff5.svg";
export { ForwardRef as ReactComponent };